module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-28.44dc1179.jpg";